module.exports = __webpack_public_path__ + "static/img/305.b1f8b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/305.png
// module id = 514
// module chunks = 3